import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=b0674e56&scoped=true&"
import script from "./app-header.vue?vue&type=script&lang=js&"
export * from "./app-header.vue?vue&type=script&lang=js&"
import style0 from "./app-header.vue?vue&type=style&index=0&id=b0674e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0674e56",
  null
  
)

export default component.exports